/**
 * window.showMessage определена в StatusMessagesList.jsx
 */

export const message = (messageClass, text, options) => {
    setTimeout(showMessage, 0, messageClass, text, options);
};

export const info = (text, options = {}) => {
    setTimeout(showMessage, 0, 'info', text, options);
};

export const alert = (text, options = {}) => {
    setTimeout(showMessage, 0, 'alert', text, options);
};

export const success = (text, options = {}) => {
    setTimeout(showMessage, 0, 'success', text, options);
};

function showMessage(msgClass, text, options) {
    window.showMessage(msgClass, text, options);
}
